import { useState, useEffect, type Dispatch, type SetStateAction } from 'react';

/**
 * Estado guardado en sessionStorage → sobrevive a navegar y volver (botón atrás) dentro de la misma
 * sesión de la pestaña. Con esto, si abres un cliente en una lista y entras al claim completo, al dar
 * "atrás" el componente se re-monta y RESTAURA el mismo cliente abierto / grupo desplegado / etc.
 * La key debe ser única por vista (ej. `claims:sel`). Para vistas reutilizables, incluye el pathname.
 */
export function usePersistentState<T>(key: string, initial: T): [T, Dispatch<SetStateAction<T>>] {
  const [v, setV] = useState<T>(() => {
    try {
      const raw = sessionStorage.getItem(key);
      return raw != null ? (JSON.parse(raw) as T) : initial;
    } catch {
      return initial;
    }
  });
  useEffect(() => {
    try {
      if (v === null || v === undefined) sessionStorage.removeItem(key);
      else sessionStorage.setItem(key, JSON.stringify(v));
    } catch {
      /* ignore (modo privado / cuota) */
    }
  }, [key, v]);
  return [v, setV];
}
